import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Layout, Spin } from "antd";
import { USERS_CONFIG, EXPERT_CONFIG, FLEET_DASHBOARD, OXE_LOGIN, SIP_TRUNK, SUBSCRIPTION, LINKS, WHATS_NEW } from "../../utils/Constants";
import UsersConfig from "../UsersConfig/UsersConfig";
import OxeLogin from "../OxeLogin/OxeLogin";
import WhatsNewData from '../WhatsNew/WhatsNewData'
import SipTrunkConfig from "../SIPTrunkConfig/SipTrunkConfig";
import { COMMON_CONTENT_STYLE, overrideComContentStyle } from "../../styles/styleUtils";
import ExpertConfig from "../ExpertConfig/ExpertConfig";
import { LoadingOutlined } from "@ant-design/icons";
import Links from "../Links/Links";


const UMCContent = (props) => {

    const [contentStyle, setContentStyle] = useState(COMMON_CONTENT_STYLE)
    const selectedApp = useSelector(state => state.common.selectedApp)
    const subHeading = useSelector(state => state.common.subHeading)
    const contentLoading = useSelector(state => state.common.contentLoading)

    useEffect(() => {
        let contentStyleTemp = { ...COMMON_CONTENT_STYLE }
        setContentStyle(overrideComContentStyle(selectedApp, contentStyleTemp, subHeading))

    }, [selectedApp, subHeading])


    return <Layout.Content style={contentStyle}>
        <Spin spinning={contentLoading} indicator={<LoadingOutlined />} size="large" wrapperClassName={contentLoading ? "spin-active" : "spin-idle"}>
            {selectedApp === OXE_LOGIN && <OxeLogin />}
            {selectedApp === USERS_CONFIG && <UsersConfig />}
            {selectedApp === SIP_TRUNK && <SipTrunkConfig />}
            {selectedApp === EXPERT_CONFIG && <ExpertConfig />}
            {selectedApp === FLEET_DASHBOARD && <></>}
            {selectedApp === SUBSCRIPTION && <></>}
            {selectedApp === LINKS && <Links />}
            {selectedApp === WHATS_NEW && <WhatsNewData/> }
        </Spin>
    </Layout.Content>
}

export default UMCContent